export enum NumberFormatCountryIso {
  German = 'de-DE',
  English = 'en-US',
  Spanish = 'es-ES',
  French = 'fr-FR'
}
